// we need to enclose all on try catch. This is to handle an error like memory full on browser
// when we got an error, on catch, we are going to disable the local cache feature
define(function (require) {
	const Logger = require('civicsUtils/application/logger');
	const CIVICS = 'CIVICS';
	const CIVICS_DATA = 'CIVICS_DATA';
	return {
		getModelCacheData: function (key) {
			let result = [];
			try {
				if (App.localCacheSettings.isEnabled) {
					let cacheData = App.sessionStorage.get(CIVICS, CIVICS_DATA);
					if (cacheData && cacheData.length > 0) {
						result = _.filter(cacheData, (data) => {
							// data should be equal to key and not expired
							return data.key == key && new Date(data.expiredDateTime) >= new Date();
						});
					}
				}
			} catch (e) {
				this.localCacheError('getModelCacheData', key, e);
			}

			return result;
		},
		saveModelCacheData: function (key, localCacheGroupName, data) {
			if (App.localCacheSettings.isEnabled) {
				try {
					let cacheData = App.sessionStorage.get(CIVICS, CIVICS_DATA);
					if (!cacheData)
						cacheData = [];

					// add the minute from config onthe current datetime and that will be the expiration of the new data
					let expirationDate = new Date();
					expirationDate.setMinutes(expirationDate.getMinutes() + App.localCacheSettings.localCacheTTL);

					let resultDataSize = this.getStringDataSizeInKiloByte(data);
					// check if data size is allowed to save on cache
					if (resultDataSize > App.localCacheSettings.localCacheMaxResponseSize)
						return;

					// remove the first item on cache if the number of data in cache is >= allowable number of data can be save
					if (cacheData.length >= App.localCacheSettings.localCacheMaxNumOfResponse) {
						cacheData.shift();
					}

					let newData = {
						key: key,
						localCacheGroupName: localCacheGroupName,
						values: data,
						expiredDateTime: expirationDate
					}
					cacheData.push(newData);

					App.sessionStorage.set(CIVICS, CIVICS_DATA, cacheData);
				} catch (e) {
					this.localCacheError('saveModelCacheData', key, e);
				}
			}
		},
		// this is use to invalidate cached data
		// it will always check for an expired data and remove on cache all the data that has the same groupName from parameter
		clearInvalidCacheData: function (localCacheGroupName) {
			if (App.localCacheSettings.isEnabled) {
				try {
					let cacheData = App.sessionStorage.get(CIVICS, CIVICS_DATA);
					if (!cacheData)
						return;

					if (cacheData.length > 0) {
						let filteredCacheData = _.filter(cacheData, (data) => {
							return (!data.localCacheGroupName || data.localCacheGroupName != localCacheGroupName) && new Date(data.expiredDateTime) >= new Date();
						});
						App.sessionStorage.set(CIVICS, CIVICS_DATA, filteredCacheData);
					}
				} catch (e) {
					this.localCacheError('clearInvalidCacheData', '', e);
				}
			}
		},
		getStringDataSizeInKiloByte: function (data) {
			// 1KB = 1024bytes
			return (new Blob([JSON.stringify(data)]).size) / 1024;
		},
		localCacheError: function (method, key, exception) {
			// diable the local cache when we encounter an error 
			App.sessionStorage.remove(CIVICS, CIVICS_DATA);
			App.localCacheSettings.isEnabled = false;
			App.sessionStorage.set(CIVICS, 'localCacheDisabled', true);
			Logger.logError('Client Cache Error:' + method + ' - Failed. Request URL:' + key + ', thrown: ' + exception.message + '.');
		}
	};
});
